import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../config";
import AuthFormContainer from "../../components/AuthFormContainer/AuthFormContainer";
import Button from "../../components/Button/Button";

const ActiveAccount = () => {
  const [loading, setLoading] = useState(false);

  const verify = () => {
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    axios
      .get(`${API}/active-account/${urlParams.get("token")}`)
      .then((response) => {
        setLoading(false);
        localStorage.setItem("authToken", JSON.stringify(response.data.token));
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        swal(
          "Activation success!",
          "You will now redirect to the App page!",
          "success",
          {
            button: "Okay",
          }
        );
        // .then(() => {
        //   history.push("/app");
        // });
      })
      .catch((err) => {
        setLoading(false);
        swal("Error!", `${err.response.data.message}`, "error", {
          button: "Okay",
        });
      });
  };

  return (
    <AuthFormContainer
      form={
        <Button text={"Active Account"} clickFn={verify} loader={loading} />
      }
    />
  );
};

export default ActiveAccount;
